import { render, staticRenderFns } from "./BButton.vue?vue&type=template&id=0040d30a"
import script from "./BButton.vue?vue&type=script&lang=js"
export * from "./BButton.vue?vue&type=script&lang=js"
import style0 from "./BButton.vue?vue&type=style&index=0&id=0040d30a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports